import { useState } from 'react';
import './StringerPhoto.scss';

export const StringerPhoto = ({
  src,
  title,
  onPhotoClick,
}: {
  src: string;
  title: string;
  onPhotoClick: () => void;
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  const handlePhotoClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onPhotoClick();
  };

  return (
    <div className="stringer-photo">
      <div className="stringer-photo-image" onClick={handlePhotoClick}>
        {isLoading && (
          <div className="stringer-photo-loader">
            <div className="stringer-photo-loader-spinner"></div>
          </div>
        )}
        {hasError && <div className="stringer-photo-error"></div>}
        <img
          src={src}
          alt={title}
          onLoad={handleImageLoad}
          onError={handleImageError}
          style={{ display: isLoading ? 'none' : 'block' }}
        />
      </div>

      <div className="stringer-photo-title">
        <span>{title}</span>
      </div>
    </div>
  );
};
